import { useMemo } from 'react'
import { useT } from '../../../../../../_metronic/i18n/Metronici18n'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { NotaVersaoUsuarioItem } from '../../core/_models'
import { useHistoricoQueryRequest } from '../../core/HistoricoQueryRequestProvider'
import { useHistoricoQueryResponse } from '../../core/HistoricoQueryResponseProvider'
import { novidadesColumns } from './columns/_columns'

export const NovidadesTable = () => {
  const { t } = useT()
  const { isLoading, isError, refetch, response } = useHistoricoQueryResponse()
  const columns = useMemo(() => novidadesColumns(t), [t])

  return (
    <CustomTable<NotaVersaoUsuarioItem>
      id='kt_table_novidades'
      ariaLabel={t('menu.novidades')}
      itemLabel={{
        singular: t('notas_versao.historico.item.singular'),
        plural: t('notas_versao.historico.item.plural'),
      }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={
        <TableEmptyState
          title={t('notas_versao.historico.vazio.titulo')}
          description={t('notas_versao.historico.vazio.descricao')}
        />
      }
      queryHooks={{
        useQueryRequest: useHistoricoQueryRequest,
        useQueryResponse: useHistoricoQueryResponse,
      }}
    />
  )
}
